import React from 'react';
import { Calendar as CalendarIcon } from 'lucide-react';

export const DateRangeFilter = ({ startDate, setStartDate, endDate, setEndDate }) => (
    <div className="flex items-center gap-4 bg-white p-4 rounded-lg shadow-sm">
        <div className="flex items-center gap-2">
            <CalendarIcon className="text-gray-500" size={20} />
            <label htmlFor="start-date" className="text-sm font-medium text-gray-700">Từ ngày:</label>
            <input 
                type="date"
                id="start-date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                className="p-2 border rounded-md"
            />
        </div>
        <div className="flex items-center gap-2">
            <label htmlFor="end-date" className="text-sm font-medium text-gray-700">Đến ngày:</label>
            <input 
                type="date"
                id="end-date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                className="p-2 border rounded-md"
            />
        </div>
    </div>
);